import React, { useContext, useEffect } from 'react'
import { css } from '@emotion/core'
import { useHistory } from '@fs/zion-router'
import GlobalContext from '../context/globalContext'
import { getPortalDeveloperDetails } from '../shared/services'

const appShellStyles = css`
  display: flex;
  padding: 100px 200px;
  background-color: rgb(246, 246, 246);
  min-height: 100vh;
  @media (max-width: 1200px) {
    flex-direction: column-reverse;
    padding: 80px 20px 80px 20px;
    min-height: auto;
  }
`
const wrapperStyles = css`
  width: 100%;
`

export default function AppShell({ children }: { children: React.ReactNode }): JSX.Element {
  const { accountInfo, updateAccountInfo } = useContext(GlobalContext)
  const history = useHistory()

  useEffect(() => {
    const fetchUserAccount = async (): Promise<void> => {
      try {
        const res = await getPortalDeveloperDetails()
        if (res?.status === 200) {
          updateAccountInfo(res?.data)
        }
        if (res?.status === 404) {
          // The user has not completed onboarding
          history.push('/onboarding')
        }
      } catch (error) {
        console.error('Error fetching user account details:', error)
        // We will want to show an error message here instead of redirecting to onboarding.
        // history.push('/onboarding')
      }
    }
    if (!accountInfo?.developerId) {
      // When a new developer signs up, they won't have a developerId until we fetch their new account details.
      fetchUserAccount()
    }
  }, [accountInfo?.developerId, history, updateAccountInfo])

  return (
    <div css={appShellStyles}>
      <div css={wrapperStyles}>{children}</div>
    </div>
  )
}
